// frontend/src/pages/ProjectList.tsx
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
const list = () => fetch("/api/v1/project.project", { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then(r => r.json()).then((r: any) => r.ok ? r.data : []);
const tasks = (id: number) => fetch(`/api/v1/project.project/${id}`, { headers: { "X-Dev-Auth": "dev", "X-Tenant-ID": "1" } }).then(r => r.json()).then((r: any) => r.ok ? r.data : null);
export default function ProjectList() {
  const qc = useQueryClient();
  const { data: projects } = useQuery({ queryKey: ["projects"], queryFn: list });
  return <div>
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-2xl font-bold">Projects</h1>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {projects?.map((p: any) => (
        <div key={p.id} className="bg-white rounded-xl shadow-sm border p-5 hover:shadow-md transition-shadow">
          <h3 className="font-semibold">{p.name}</h3>
          <span className={`inline-block mt-2 px-2 py-0.5 rounded-full text-xs font-medium ${p.state === "open" ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"}`}>{p.state}</span>
          <p className="text-xs text-gray-400 mt-3">Created: {new Date(p.create_date).toLocaleDateString()}</p>
        </div>
      ))}
      {(!projects || projects.length === 0) && <p className="text-gray-400 col-span-3 text-center py-8">No projects</p>}
    </div>
  </div>;
}
